module.exports = __webpack_public_path__ + "assets/hushijie.0f76f1f5.svg";